module.exports = __webpack_public_path__ + "img/part7_x3.ba64d13a.png";